import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { buildContactsSearchRequest } from '../contacts/contacts-query';
import { IContact } from '../models/contact';
import { ContactService } from '../services/contact.service';

@Injectable({
  providedIn: 'root'
})
export class ContactsResolver  {

  constructor(private contactService: ContactService){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IGridResult<IContact[]>> {
    return this.contactService.listContacts(buildContactsSearchRequest(route.queryParamMap))
    .pipe(
      map(response => {
        return {
          data: response.data,
          total: response.totalCount
        };
      })
    )
  }
}
